var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightbulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 19V16H11V19H9ZM0 10V8H3V10H0ZM17 10V8H20V10H17ZM16 16.9L13.9 14.8L15.3 13.4L17.4 15.5L16 16.9ZM4 16.9L2.6 15.5L4.7 13.4L6.1 14.8L4 16.9ZM6.4625 12.5375C5.4875 11.5625 5 10.3833 5 9C5 8.2 5.17917 7.45417 5.5375 6.7625C5.89583 6.07083 6.38333 5.48333 7 5V0H13V5C13.6167 5.48333 14.1042 6.07083 14.4625 6.7625C14.8208 7.45417 15 8.2 15 9C15 10.3833 14.5125 11.5625 13.5375 12.5375C12.5625 13.5125 11.3833 14 10 14C8.61667 14 7.4375 13.5125 6.4625 12.5375ZM9 4.1C9.16667 4.06667 9.33333 4.04167 9.5 4.025C9.66667 4.00833 9.83333 4 10 4C10.1667 4 10.3333 4.00833 10.5 4.025C10.6667 4.04167 10.8333 4.06667 11 4.1V2H9V4.1ZM10 12C10.8333 12 11.5417 11.7083 12.125 11.125C12.7083 10.5417 13 9.83333 13 9C13 8.16667 12.7083 7.45833 12.125 6.875C11.5417 6.29167 10.8333 6 10 6C9.16667 6 8.45833 6.29167 7.875 6.875C7.29167 7.45833 7 8.16667 7 9C7 9.83333 7.29167 10.5417 7.875 11.125C8.45833 11.7083 9.16667 12 10 12Z",
    fill: "#F8FAFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulb);
export default __webpack_public_path__ + "static/media/lightbulb.446bf8d46a4d9900126899a3ba8515e6.svg";
export { ForwardRef as ReactComponent };